// @ts-nocheck
import { notification } from 'antd';
import {
    CATEGORY_WEIGHT_FIELDS,
    EMAIL_ADDRESSES_FIELDS,
    EMAIL_GROUPS_FIELDS,
    EVENT_MONITORING_FIELDS,
    EVENT_STATUSES,
    LEAGUE_WEIGHT_FIELDS,
    LOG_SERVICE_NAMES,
    MARKET_STATUSES,
    MARKET_TYPES,
    newDateAndTimeFormatWithSeconds,
    OPERATOR_FIELDS,
    RISK_STATUSES,
    SELECT_ALL_OPTION,
    SPORT_WEIGHT_FIELDS,
    BET_TYPES_OPTIONS,
    USER_FIELDS,
    USER_INTERFACE_RETAIL_FIELDS,
    SERVER_ERRORS_LOGS_FIELDS,
    EXPIRATION_TIME_TYPES,
    FILTER_PARAMS,
    KYC_LOGS_FIELDS,
    PLAYER_UPDATE_FIELDS,
    SELF_EXCLUDE_FIELDS,
} from './constants';
import { convertToOrdinal } from './methods/convertToOrdinal';
import moment from 'moment';
import MATCH_DESCRIPTIONS from './match-descriptions';
import PlayerDetailsLink from '../components/shared/Table/PlayerDetailsLink/PlayerDetailsLink';

export const renderPaginationTotal = (total, [min, max]) => `${min}-${max} of ${total}`;

export const roundNumber = (number, decimalPlaces = 0) => {
    const power = Math.pow(10, decimalPlaces);

    return (Math.round(number * power + Number.EPSILON) / power).toFixed(decimalPlaces);
};

const getFieldName = (key, serviceName) => {
    switch (serviceName) {
        case LOG_SERVICE_NAMES.operator:
            return OPERATOR_FIELDS[key];
        case LOG_SERVICE_NAMES.sportWeight:
            return SPORT_WEIGHT_FIELDS[key];
        case LOG_SERVICE_NAMES.categoryWeight:
            return CATEGORY_WEIGHT_FIELDS[key];
        case LOG_SERVICE_NAMES.leagueWeight:
            return LEAGUE_WEIGHT_FIELDS[key];
        case LOG_SERVICE_NAMES.email:
            return EMAIL_ADDRESSES_FIELDS[key];
        case LOG_SERVICE_NAMES.emailGroup:
            return EMAIL_GROUPS_FIELDS[key];
        case LOG_SERVICE_NAMES.user:
            return USER_FIELDS[key] || key;
        case LOG_SERVICE_NAMES.eventMonitoring:
            return EVENT_MONITORING_FIELDS[key];
        case LOG_SERVICE_NAMES.userInterfaceRetail:
            return USER_INTERFACE_RETAIL_FIELDS[key];
        case LOG_SERVICE_NAMES.serverErrors:
            return SERVER_ERRORS_LOGS_FIELDS[key];
        case LOG_SERVICE_NAMES.kycDocumentOperationStatus:
            return KYC_LOGS_FIELDS[key];
        case LOG_SERVICE_NAMES.playerDetailsUpdate:
            return PLAYER_UPDATE_FIELDS[key];
        case LOG_SERVICE_NAMES.selfExclusion:
            return SELF_EXCLUDE_FIELDS[key];
        default:
            return undefined;
    }
};

const findChangedValues = ({ oldData, newData, transaction, serviceName, parentChangedFields }) => {
    const changedFields = parentChangedFields || transaction.changedFields;
    const oldLogData = oldData || {};
    const newLogData = newData || {};

    const logData = Object.keys(newLogData).length < Object.keys(oldLogData).length ? oldLogData : newLogData;

    Object.keys(logData).forEach(key => {
        if (typeof newLogData[key] === 'object' && newLogData[key] !== null && !Array.isArray(newLogData[key])) {
            findChangedValues({
                oldData: oldLogData[key],
                newData: newLogData[key],
                transaction,
                serviceName,
                parentChangedFields: changedFields,
            });
            return;
        }

        let oldValue = oldLogData[key];
        let newValue = newLogData[key];

        if (Array.isArray(newValue) || Array.isArray(oldValue)) {
            const sample = newValue?.[0] ?? oldValue?.[0];
            if (typeof sample === 'object' && sample !== null) {
                const fieldName = getFieldName(key, serviceName);
                if (!fieldName) return;

                const items = [];
                const length = Math.max(newValue?.length ?? 0, oldValue?.length ?? 0);
                for (let index = 0; index < length; index++) {
                    const elementChangedFields = [];
                    findChangedValues({
                        oldData: oldValue?.[index],
                        newData: newValue?.[index],
                        transaction,
                        serviceName,
                        parentChangedFields: elementChangedFields,
                    });

                    if (elementChangedFields.length) {
                        items.push({ key: index, changedFields: elementChangedFields });
                    }
                }

                if (items.length) {
                    changedFields.push({
                        field: fieldName,
                        key,
                        items,
                    });
                }
                return;
            }
            newValue = newValue?.join(', ');
            oldValue = oldValue?.join(', ');
        }

        const fieldName = getFieldName(key, serviceName);
        console.log({ oldValue, newValue, fieldName, key, serviceName });

        if (!fieldName) return;

        if (newValue == null && oldValue == null) return;

        if (newValue !== oldValue) {
            if (typeof newValue === 'boolean') {
                newValue = newValue ? 'ACTIVE' : 'INACTIVE';
            }
            if (typeof oldValue === 'boolean') {
                oldValue = oldValue ? 'ACTIVE' : 'INACTIVE';
            }
            changedFields.push({
                field: fieldName,
                key,
                newValue,
                oldValue,
            });
        }
    });
};

export const formatLogsData = data => {
    return data.map(transaction => {
        const newTransaction = { ...transaction, changedFields: [] };
        const { logData = {}, serviceName } = transaction;
        const oldData = logData.oldData;
        const newData = logData.newData;
        if (logData) {
            delete logData.oldData?.cashierResponseDtos;
            delete logData.newData?.cashierResponseDtos;
            findChangedValues({ oldData, newData, transaction: newTransaction, serviceName });
            return newTransaction;
        }
    });
};

export const formatKycLogsData = (data, serviceName) => {
    return data.map(transaction => {
        const newTransaction = { ...transaction, changedFields: [] };
        const { logData = {} } = transaction;
        const oldData = logData.oldData;
        const newData = logData.newData;
        if (logData) {
            findChangedValues({
                oldData,
                newData,
                serviceName,
                transaction: newTransaction,
            });
            return newTransaction;
        }
    });
};

export const handleErrorNotification = (errors, defaultErrorMessage) => {
    const errorMessage = errors?.[0]?.description;

    notification.error({ message: errorMessage || defaultErrorMessage || 'Something went wrong.' });
};

export const sortOutcomes = (outcomes, fieldKey) => {
    const parseValue = v => {
        // extract number (defaults to 0 if not present)
        let n = +(v.match(/\d+$/) || [0])[0];
        let str = v.replace(n, ''); // extract string part
        return [str, n];
    };

    if (outcomes && outcomes.length > 0) {
        let newOutcomes = [...outcomes];

        newOutcomes.sort((a, b) => {
            a = parseValue(a[fieldKey]);
            b = parseValue(b[fieldKey]);

            // compare string part alphabetically
            let result = a[0].localeCompare(b[0]);
            // if the string part is the same, compare the number part
            return result === 0 ? a[1] - b[1] : result;
        });

        return newOutcomes;
    }

    return [];
};

export const generateEventStatusStyles = status => {
    const styles = {};

    switch (status) {
        case EVENT_STATUSES.live: {
            styles.backgroundColor = '#f6ffed';
            styles.color = '#389e0d';
            break;
        }
        case EVENT_STATUSES.suspended:
        case EVENT_STATUSES.abandoned:
        case EVENT_STATUSES.delayed:
        case EVENT_STATUSES.postponed:
        case EVENT_STATUSES.interrupted: {
            styles.backgroundColor = '#fff7e6';
            styles.color = '#d46b08';
            break;
        }
        case EVENT_STATUSES.cancelled: {
            styles.backgroundColor = '#fff1f0';
            styles.color = '#cf1322';
            break;
        }
        default: {
        }
    }

    return styles;
};

export const getNameFromId = (list, id) => list.find(item => item.id === id)?.name || '';
export const getCityNameFromId = (list, id) => list.find(item => item.id === id)?.cityName || '';
export const getRegionName = (list, cityId, regionId) =>
    list.find(item => item.id === cityId)?.regions?.find(region => region.id === regionId)?.name || '';

export const formatSpecifierName = ({ name, specifiers, teams, tournamentName, playerNames }) => {
    if (!name) return '';

    const patterns = findPatterns.get(name, '{', '}');

    let formattedName = name;

    patterns.forEach(pattern => {
        let replaceValue = '';

        if (pattern[0] === '!') {
            const specifierName = pattern.slice(1);
            const specifierValue = specifiers[specifierName];

            if (specifierValue) {
                replaceValue = convertToOrdinal(specifierValue);
            }
        } else if (pattern[0] === '+' || pattern[0] === '-') {
            const specifierName = pattern.slice(1);
            const specifierValue = specifiers[specifierName];
            if (specifierValue) {
                replaceValue = pattern[0] === '+' ? specifierValue : specifierValue * -1;

                if (Number(replaceValue) > 0) {
                    replaceValue = `+${Math.abs(replaceValue)}`;
                } else if (Number(replaceValue) < 0) {
                    replaceValue = `-${Math.abs(replaceValue)}`;
                }
            }
        } else if (pattern.includes('+')) {
            let newPattern = pattern;
            let specifierValue = '';

            if (newPattern[0] === '!') {
                newPattern = newPattern.slice(1);
            }

            if (newPattern[0] === '(') {
                newPattern = newPattern.slice(1, newPattern.length - 1);
                const [specifierName, constant] = newPattern.split('+');
                const foundSpecifierValue = specifiers[specifierName];

                if (foundSpecifierValue) {
                    specifierValue = foundSpecifierValue + Number(constant);
                }
            }

            if (pattern[0] === '!') {
                replaceValue = convertToOrdinal(specifierValue);
            } else {
                replaceValue = specifierValue;
            }
        } else if (pattern.includes('-')) {
            let newPattern = pattern;
            let specifierValue = '';

            if (newPattern[0] === '!') {
                newPattern = newPattern.slice(1);
            }

            if (newPattern[0] === '(') {
                newPattern = newPattern.slice(1, newPattern.length - 1);
                const [specifierName, constant] = newPattern.split('+');
                const foundSpecifierValue = specifiers[specifierName];

                if (foundSpecifierValue) {
                    specifierValue = foundSpecifierValue - Number(constant);
                }
            }

            if (pattern[0] === '!') {
                replaceValue = convertToOrdinal(specifierValue);
            } else {
                replaceValue = specifierValue;
            }
        } else if (pattern.includes('$competitor')) {
            const competitorNumber = pattern[pattern.length - 1];

            if (competitorNumber === '1') {
                replaceValue = `<strong>${teams.home}</strong>`;
            } else if (competitorNumber === '2') {
                replaceValue = `<strong>${teams.away}</strong>`;
            }
        } else if (pattern.includes('$event')) {
            if (pattern.includes('tournament')) {
                replaceValue = tournamentName;
            } else if (pattern.includes('match')) {
                replaceValue = `<strong>${teams.home} - ${teams.away}</strong>`;
            }
        } else if (pattern.includes('%player')) {
            const specifierValue = specifiers[pattern.slice(1)];
            replaceValue = playerNames[specifierValue];
        } else {
            const specifierValue = specifiers[pattern];

            if (formattedName.includes(`({${pattern}})`)) {
                replaceValue = specifierValue ? `${specifierValue}` : '';
            } else {
                replaceValue = specifierValue ? `(${specifierValue})` : '';
            }
        }

        formattedName = formattedName.replace(`{${pattern}}`, replaceValue);
    });

    return formattedName;
};

export const findPatterns = {
    results: [],
    string: '',
    getFromBetween: function (startingCharacter, endingCharacter) {
        if (this.string.indexOf(startingCharacter) < 0 || this.string.indexOf(endingCharacter) < 0) return false;
        var SP = this.string.indexOf(startingCharacter) + startingCharacter.length;
        var string1 = this.string.substr(0, SP);
        var string2 = this.string.substr(SP);
        var TP = string1.length + string2.indexOf(endingCharacter);
        return this.string.substring(SP, TP);
    },
    removeFromBetween: function (startingCharacter, endingCharacter) {
        if (this.string.indexOf(startingCharacter) < 0 || this.string.indexOf(endingCharacter) < 0) return false;
        var removal = startingCharacter + this.getFromBetween(startingCharacter, endingCharacter) + endingCharacter;
        this.string = this.string.replace(removal, '');
    },
    getAllResults: function (startingCharacter, endingCharacter) {
        // first check to see if we do have both substrings
        if (this.string.indexOf(startingCharacter) < 0 || this.string.indexOf(startingCharacter) < 0) return;

        // find one result
        var result = this.getFromBetween(startingCharacter, endingCharacter);
        // push it to the results array
        this.results.push(result);
        // remove the most recently found one from the string
        this.removeFromBetween(startingCharacter, endingCharacter);

        // if there's more substrings
        if (this.string.indexOf(startingCharacter) > -1 && this.string.indexOf(endingCharacter) > -1) {
            this.getAllResults(startingCharacter, endingCharacter);
        } else return;
    },
    get: function (string, startingCharacter, endingCharacter) {
        this.results = [];
        this.string = string;
        this.getAllResults(startingCharacter, endingCharacter);
        return this.results;
    },
};

export const getMarketStatusColor = ({ marketStatus, riskStatus }) => {
    if (RISK_STATUSES[riskStatus]) {
        return RISK_STATUSES[riskStatus].color;
    }

    const marketStatusInfo = MARKET_STATUSES[marketStatus];

    return marketStatusInfo.backgroundColor;
};

export const checkMarketType = ({ marketType, specifiers }) => {
    if (!marketType) return true;

    let isValid = true;

    const specifierValues = Object.values(specifiers).filter(value => !isNaN(value));

    switch (marketType) {
        case MARKET_TYPES.integer: {
            if (specifierValues.some(value => value % 1 !== 0)) isValid = false;
            break;
        }
        case MARKET_TYPES.float: {
            if (specifierValues.some(value => value % 1 !== 0.5)) isValid = false;
            break;
        }
        case MARKET_TYPES.asian: {
            if (specifierValues.some(value => value % 1 !== 0.25)) isValid = false;
            break;
        }
        default: {
            //
        }
    }

    return isValid;
};

export const getMatchDescription = (statusId, { type = 'short', locale = 'eng' } = {}) => {
    if (statusId === undefined || statusId === null) return '';

    const description = MATCH_DESCRIPTIONS[statusId.toString()];

    if (!description) return '';

    const { label, shortLabel } = description;

    if (type === 'short') {
        return shortLabel[locale];
    }

    return label[locale];
};

export const filterVisibleColumns = (visibleColumns, column) => {
    return column && (!column.columnKey || visibleColumns[column.columnKey]);
};

export const transformVisibleColumns = (columns, state) => {
    return Object.values(columns)
        .filter(column => !column.export?.exportOnly)
        .reduce((result, column) => ({ ...result, [column.key]: state }), {});
};

export const renderTransactionDate = date => {
    const formatDate = date => moment(parseInt(date)).format(newDateAndTimeFormatWithSeconds);
    if (date.length > 13) {
        const dateRange = date.split('-');
        return [formatDate(dateRange[0]), '-', formatDate(dateRange[1])];
    } else {
        return formatDate(date);
    }
};

export const getTicketStatus = (status, subStatus) => (status.toLowerCase() === 'open' ? status : subStatus);

export const renderGroupName = (groupParamName, group, groupByOptions) => {
    if (groupParamName === groupByOptions?.day?.paramName) {
        return moment(group.name).format('MMMM D');
    } else if (groupParamName === groupByOptions?.month?.paramName) {
        return moment(group.name).format('MMMM');
    } else if (groupParamName === groupByOptions?.competitionType?.paramName) {
        return group.name;
    } else if (groupParamName === groupByOptions?.customer?.paramName) {
        return <PlayerDetailsLink customerId={group.name} />;
    } else if (groupParamName === groupByOptions?.paymentMethod?.paramName) {
        return group.name;
    } else {
        return group.name;
    }
}; //TODO REMOVE ? AFTER DEPOLOYING ONLINE AND RETAIL

const groupRenderFormat = {
    DAY: 'MMMM D',
    MONTH: 'MMMM',
};

export const renderGroup = (groupParamName, group) => {
    const renderFormat = groupRenderFormat[groupParamName];

    if (groupParamName.toLowerCase() === FILTER_PARAMS.player) {
        return <PlayerDetailsLink customerId={group} />;
    } else if (renderFormat) {
        return moment(group).format(renderFormat);
    }

    return group;
};

export const findTicketTypeById = id => {
    return BET_TYPES_OPTIONS.find(item => item.id === id)?.name || SELECT_ALL_OPTION.name;
};

export const concatWith = (delimiter, ...elements) => elements.join(delimiter);

export const getSpecifierLabel = values => values.map(value => value.type + '-' + value.value).join(', ');

const objectsEqual = (o1, o2) =>
    typeof o1 === 'object' && Object.keys(o1).length > 0
        ? Object.keys(o1).length === Object.keys(o2).length && Object.keys(o1).every(p => objectsEqual(o1[p], o2[p]))
        : o1 === o2;

export const arraysEqual = (a1, a2) => a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));

export const validateMbn = mbnList => {
    const hasOneMbn = mbnList.some(mbn => mbn === 1);
    const hasThreeMbn = mbnList.some(mbn => mbn === 3);

    let hasErrors = false;

    if (hasThreeMbn) {
        const maxMbn = Math.max(...mbnList);

        if (mbnList.length < maxMbn && !hasOneMbn) {
            hasErrors = true;
        }
    }

    return hasErrors;
};

export const generateNameRegEx = name => {
    let regEx = '';

    let newStr = name.split(' ');

    const patterns = findPatterns.get(name, '{', '}');
    const pattersWithBracket = findPatterns.get(name, '({', '})');

    const modifiedPatterns = patterns.map(item => `{${item}}`);
    const modifiedPatternsWithBrackets = pattersWithBracket.map(item => `({${item}})`);

    const newArr = [...newStr];
    const specialCharacters = ['(', ')', '+'];
    const splitCharacters = [':', '-', ',', '/'];

    newStr.forEach((item, index) => {
        if (modifiedPatterns.includes(item)) {
            newArr[index] = item[1] === '$' ? item[0] + '\\' + item.slice(1) : item;

            newArr[index] = '.*' + newArr[index] + '.*';
        } else if (modifiedPatternsWithBrackets.includes(item)) {
            newArr[index] = '.*' + item.slice(1, item.length - 1) + '.*';
        } else {
            let splitedItem;

            splitCharacters.forEach(char => {
                if (
                    item.includes(char) &&
                    (item[item.indexOf(char) - 1] === '}' || item[item.indexOf(char) + 1] === '{')
                ) {
                    splitedItem = item.split(char);
                }
            });

            if (splitedItem) {
                newArr[index] = splitedItem
                    .map(item => {
                        if (item[0] === '{') {
                            return item[1] === '$' ? item[0] + '\\' + item.slice(1) : item;
                        } else return '.*';
                    })
                    .join('.*');
            } else {
                newArr[index] = '.*';
            }
        }

        regEx = newArr.join(' ');

        specialCharacters.forEach(char => {
            if (regEx.includes(char)) {
                regEx = regEx.replace(char, `\\${char}`);
            }
        });
    });

    regEx = new RegExp(regEx.split(' ').join(''));

    return regEx;
};

export const renderBonusExpirationTimeValue = values => {
    const { expirationTimeValue: value, expirationTimeType: type } = values;

    let formattedValue;

    if (value) {
        switch (type) {
            case EXPIRATION_TIME_TYPES.daysTillExpiration: {
                formattedValue = Number(value);
                break;
            }
            case EXPIRATION_TIME_TYPES.exactDateAndTime: {
                formattedValue = moment(value).endOf('day').valueOf();
                break;
            }
            case EXPIRATION_TIME_TYPES.dayOfTheWeek: {
                formattedValue = value;
                break;
            }
            default: {
                formattedValue = null;
                break;
            }
        }
    } else {
        formattedValue = null;
    }

    return formattedValue;
};

const extractDateRange = (inputDate, dateFormat, selectedRange) => {
    const formStartDate = selectedRange[0];
    const formEndDate = selectedRange[1];

    let [startDate, endDate] = [moment(inputDate).startOf(dateFormat), moment(inputDate).endOf(dateFormat)];

    if (startDate.isBefore(formStartDate)) {
        startDate = formStartDate;
    }

    if (endDate.isAfter(formEndDate)) {
        endDate = formEndDate;
    }

    return [startDate, endDate];
};

export const getPlayerParamsByGroup = (groupBy, field, selectedRange) => {
    let params = {};
    if (groupBy === 'MONTH') {
        params.range = extractDateRange(moment(field, 'MMMM'), 'month', selectedRange);
    } else if (groupBy === 'DAY') {
        params.range = extractDateRange(moment(field), 'day', selectedRange);
    } else if (groupBy === 'CLIENT_TYPE') {
        params.clientType = [field];
    } else if (groupBy === 'OPERATING_SYSTEM') {
        params.operatingSystem = [field];
    }

    return params;
};

export function scrollToTop(selectors: string) {
    document.body.querySelector(selectors).scrollTo({ top: 0, behavior: 'smooth' });
}
